// extracted by mini-css-extract-plugin
export default {"profileContainer":"styles_profileContainer__YCLYA","table":"styles_table__AiQ51"};